let appointmentTimeOptions = [
	<option value={1}>Next appointment</option>,
	<option value={2}>Future Appointments</option>,
	<option value={3}>Past and future Appointments</option>,
];

export default appointmentTimeOptions;
